import { initializeApp } from 'firebase/app';
import { env } from '@env';

export const firebaseApp = initializeApp(env.firebaseOptions, 'chihaya');
